function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { Menu, MenuGrid, MenuItem, MenuTitle } from "@sprout/list-navigation/dist/Menu";
import RenderIfChildExists from "@sprout/client-components/dist/RenderIfChildExists";
import { useApp_CreatePostMutation, UserType, useTopicPage_LeaveTopicMutation } from "sprout-graphql";
import { AddBoxOutlined, AdminPanelSettingsOutlined, ArchiveOutlined, AutoDeleteOutlined, DeleteOutlined, EditOutlined, ExitToAppOutlined, HorizontalRuleOutlined, LeafLine, LocalOfferOutlined, NotificationsNoneOutlined, PeopleOutlined, PushPinOutlined, RestoreFromTrashOutlined, Search, SettingsOutlined, Timeline, UnarchiveOutlined } from "sprout-ui-icons";
import useStarTopic from "@sprout/client-components/dist/Topic/graphql/mutations/useStarTopic";
import { useActionRegistryNavigation, useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import useSetDefaultTopic from "@sprout/client-components/dist/Topic/graphql/mutations/useSetDefaultTopic";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { getItemUrl } from "sprout-lib";
import Divider from "sprout-ui-dom/dist/Divider";
import { Flex, Text } from "sprout-ui-primitives";
import Avatar from "@sprout/client-components/dist/Avatar";
import useToggle from "@sprout/hooks/dist/useToggle";
import { MoveItemsDialog } from "@sprout/client-components/dist/Dialog_next";
import ActionConfirmationDialog from "@sprout/client-components/dist/Dialog/ActionConfirmationDialog";
import { Link, useHistory } from "react-router-dom";
import { admin } from "@sprout/client-lib";
import useDeleteItems from "@sprout/client-graphql/dist/mutations/useDeleteItems";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { MenuItemShare, useMenuItemPageCopy } from "@sprout/client-components/dist/MenuItemReusable";
import { useSetItemsArchived, useSetItemsDeleted } from "@sprout/client-graphql";
import { useGoBack } from "@sprout/providers/dist/goBack";
import { useTopicPage } from "../TopicPageContext";
import TopicPageViewsTopicMenuLabels from "./TopicPageViewsTopicMenuLabels";
import useTopicAuthorization from "./useTopicAuthorization";
const TopicPageViewsTopicMenu = (props)=>{
    var ref1;
    const { isPartOfTopic  } = useTopicPage();
    const { topic , menuState  } = props;
    const { rootTopicOrSelf , isExplicitlyArchived , isExplicitlyDeleted , isRootTopic , id , nodeId , currentUserHasStarred , parentTopic , public: topicPublic , teamVisible ,  } = topic;
    const { special , owner , labels: { nodes: labels  } = {
        nodes: undefined
    } ,  } = rootTopicOrSelf || {};
    const isSpecial = !!special;
    const snackbarOverwrite = isRootTopic ? "Tree" : "Branch";
    const rootURL = getItemUrl(rootTopicOrSelf, owner);
    const parentURL = getItemUrl(parentTopic, owner);
    const settingsURL = `${rootURL}/settings`;
    const notificationsURL = `${rootURL}/notifications`;
    const labelsURL = `${rootURL}/labels`;
    //
    const authorization = useTopicAuthorization(topic);
    //
    useActionRegistryNavigation("VIEW_LABELS", labelsURL);
    useActionRegistryNavigation("VIEW_SETTINGS", settingsURL, {
        skip: !authorization.viewSettings
    });
    const history = useHistory();
    const searchURL = useMemo(()=>({
            pathname: `${rootURL}/search`,
            state: {
                focusSearchInput: true
            }
        }), [
        rootURL
    ]);
    useActionRegistryGlobalHandler("SEARCH_TOPIC", useCallback(()=>{
        history.push(searchURL);
        return true;
    }, [
        history,
        searchURL
    ]), {
        // Required in Chrome, prevent the letter `e` from filling the input
        preventDefault: true
    });
    //
    const selectedItemsToMove = useMemo(()=>[
            topic
        ], [
        topic
    ]);
    const [move, openMove, closeMove] = useToggle();
    useActionRegistryGlobalHandler("PAGE_MOVE", useCallback(()=>{
        openMove();
        return true;
    }, [
        openMove
    ]), {
        skip: !authorization.move
    });
    //
    const starTopic = useStarTopic({
        star: !currentUserHasStarred,
        topicId: id,
        nodeId
    });
    //
    const currentUser = useCurrentUser();
    const currentUserId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
    const defaultTopicId = currentUser === null || currentUser === void 0 ? void 0 : (ref1 = currentUser.defaultTopic) === null || ref1 === void 0 ? void 0 : ref1.id;
    const setDefaultTopic = useSetDefaultTopic({
        defaultTopicId: id
    });
    //
    const { goBack  } = useGoBack();
    const setItemsArchived = useSetItemsArchived();
    useActionRegistryGlobalHandler("PAGE_TOGGLE_ARCHIVE", useCallback(()=>{
        const nextIsExplicitlyArchived = !isExplicitlyArchived;
        setItemsArchived({
            items: [
                topic
            ],
            isExplicitlyArchived: nextIsExplicitlyArchived,
            snackbarOverwrite: snackbarOverwrite,
            callback () {
                if (nextIsExplicitlyArchived) goBack();
            }
        });
        return true;
    }, [
        snackbarOverwrite,
        goBack,
        isExplicitlyArchived,
        setItemsArchived,
        topic, 
    ]), {
        skip: !authorization.archive
    });
    //
    const setItemsDeleted = useSetItemsDeleted();
    useActionRegistryGlobalHandler("PAGE_TOGGLE_DELETE", useCallback(()=>{
        const nextIsExplicitlyDeleted = !isExplicitlyDeleted;
        setItemsDeleted({
            items: [
                topic
            ],
            isExplicitlyDeleted: nextIsExplicitlyDeleted,
            snackbarOverwrite: snackbarOverwrite,
            callback () {
                if (nextIsExplicitlyDeleted) goBack();
            }
        });
        return true;
    }, [
        snackbarOverwrite,
        goBack,
        isExplicitlyDeleted,
        setItemsDeleted,
        topic, 
    ]), {
        skip: !authorization.trash
    });
    //
    const [deleting, openDelete, closeDelete] = useToggle();
    const deleteItems = useDeleteItems();
    const deleteTopic = useCallback(()=>{
        if (!deleting) {
            openDelete();
            return;
        }
        closeDelete();
        deleteItems({
            itemIds: [
                id
            ],
            type: snackbarOverwrite,
            callback: ()=>{
                if (isRootTopic) history.replace(owner ? `/${owner.username}` : "/");
                else history.replace(parentURL);
            }
        });
    }, [
        closeDelete,
        deleteItems,
        deleting,
        snackbarOverwrite,
        history,
        id,
        isRootTopic,
        openDelete,
        owner,
        parentURL, 
    ]);
    //
    const showSnackbar = useSnackbar();
    const [leave, openLeave, closeLeave] = useToggle();
    const [leaveMutation] = useTopicPage_LeaveTopicMutation();
    const leaveTopic = useCallback(()=>{
        if (!leave) {
            openLeave();
            return;
        }
        closeLeave();
        leaveMutation({
            variables: {
                topicId: id,
                userId: Number(currentUserId)
            }
        }).then(()=>{
            history.replace(currentUser ? `/${currentUser.username}` : "/");
            showSnackbar({
                message: "You have left the tree"
            });
        }).catch(()=>{
            showSnackbar.error();
        });
    }, [
        leave,
        closeLeave,
        leaveMutation,
        id,
        currentUserId,
        openLeave,
        history,
        currentUser,
        showSnackbar, 
    ]);
    //
    const [createPost] = useApp_CreatePostMutation();
    useActionRegistryGlobalHandler("ADD_DRAFT_POST", useCallback(()=>{
        createPost({
            variables: {
                parentTopicId: id
            }
        }).then(({ data  })=>{
            var ref;
            const item = data === null || data === void 0 ? void 0 : (ref = data.createItem) === null || ref === void 0 ? void 0 : ref.item;
            if (item) history.push(getItemUrl(item), {
                focusDescriptionEditor: true
            });
        }).catch(()=>{
            showSnackbar.error();
        });
        return true;
    }, [
        createPost,
        history,
        id,
        showSnackbar
    ]));
    //
    const [, MenuItemCopy] = useMenuItemPageCopy(isSpecial);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            authorization.move && /*#__PURE__*/ _jsx(MoveItemsDialog, {
                selectedItems: selectedItemsToMove,
                open: move,
                onRequestClose: closeMove
            }),
            (authorization.delete || admin(currentUser)) && /*#__PURE__*/ _jsx(ActionConfirmationDialog, {
                title: `Delete ${snackbarOverwrite.toLowerCase()}`,
                content: `Are you sure you want to permanently delete this ${snackbarOverwrite.toLowerCase()}?`,
                actionText: "Delete",
                onActionClick: deleteTopic,
                open: deleting,
                onRequestClose: closeDelete
            }),
            authorization.leave && /*#__PURE__*/ _jsx(ActionConfirmationDialog, {
                title: "Leave tree",
                content: "When you leave a tree, your content will remain unless you delete it before leaving.",
                actionText: "Leave",
                onActionClick: leaveTopic,
                open: leave,
                onRequestClose: closeLeave
            }),
            /*#__PURE__*/ _jsxs(Menu, _objectSpread({}, menuState, {
                $size: "lg",
                placement: "top",
                children: [
                    /*#__PURE__*/ _jsxs(RenderIfChildExists, {
                        component: /*#__PURE__*/ _jsx(MenuGrid, {
                            mb: 5
                        }),
                        children: [
                            (authorization.editTopic || authorization.editSection) && /*#__PURE__*/ _jsx(MenuItem, {
                                variant: "tile",
                                label: "Edit",
                                icon: EditOutlined,
                                action: "PAGE_EDIT_TOPIC"
                            }),
                            authorization.viewSettings && /*#__PURE__*/ _jsx(MenuItem, {
                                variant: "tile",
                                label: "Settings",
                                icon: SettingsOutlined,
                                action: "VIEW_SETTINGS"
                            }),
                            authorization.move && /*#__PURE__*/ _jsx(MenuItem, {
                                variant: "tile",
                                action: "PAGE_MOVE"
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                variant: "tile",
                                icon: Search,
                                label: "Search",
                                action: "SEARCH_TOPIC"
                            }),
                            authorization.archive && /*#__PURE__*/ _jsx(MenuItem, {
                                variant: "tile",
                                action: "PAGE_TOGGLE_ARCHIVE",
                                icon: isExplicitlyArchived ? UnarchiveOutlined : ArchiveOutlined,
                                label: isExplicitlyArchived ? "Unarchive" : "Archive"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(MenuTitle, {
                        children: `${snackbarOverwrite} options`
                    }),
                    authorization.star && /*#__PURE__*/ _jsx(MenuItem, {
                        label: `${currentUserHasStarred ? "Remove from" : "Pin to"} Home`,
                        icon: PushPinOutlined,
                        onClick: starTopic
                    }),
                    authorization.addDivider && /*#__PURE__*/ _jsx(MenuItem, {
                        label: "Insert divider",
                        icon: HorizontalRuleOutlined,
                        action: "ADD_DIVIDER"
                    }),
                    authorization.addDraftLeaf && /*#__PURE__*/ _jsx(MenuItem, {
                        label: "Draft leaf",
                        icon: LeafLine,
                        action: "ADD_DRAFT_POST"
                    }),
                    !isSpecial && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(MenuItemCopy, {
                                type: snackbarOverwrite.toLowerCase()
                            }),
                            /*#__PURE__*/ _jsx(MenuItemShare, {
                                type: snackbarOverwrite.toLowerCase()
                            })
                        ]
                    }),
                    defaultTopicId !== id && isPartOfTopic && /*#__PURE__*/ _jsx(MenuItem, {
                        label: `Set as default ${snackbarOverwrite.toLowerCase()}`,
                        icon: AddBoxOutlined,
                        onClick: setDefaultTopic
                    }),
                    authorization.viewMembers && /*#__PURE__*/ _jsx(MenuItem, {
                        label: "Members",
                        icon: PeopleOutlined,
                        action: "VIEW_MEMBERS"
                    }),
                    !isSpecial && !!currentUser && /*#__PURE__*/ _jsx(MenuItem, {
                        label: "Manage notifications",
                        icon: NotificationsNoneOutlined,
                        to: notificationsURL
                    }),
                    authorization.trash && /*#__PURE__*/ _jsx(MenuItem, {
                        label: `${isExplicitlyDeleted ? "Restore" : "Delete"} ${snackbarOverwrite.toLowerCase()}`,
                        icon: isExplicitlyDeleted ? RestoreFromTrashOutlined : DeleteOutlined,
                        action: "PAGE_TOGGLE_DELETE"
                    }),
                    authorization.delete && /*#__PURE__*/ _jsx(MenuItem, {
                        label: "Delete forever",
                        icon: DeleteOutlined,
                        onClick: deleteTopic
                    }),
                    !(authorization.trash || authorization.delete) && admin(currentUser) && /*#__PURE__*/ _jsx(MenuItem, {
                        label: "Admin - delete abusive content",
                        icon: AdminPanelSettingsOutlined,
                        onClick: deleteTopic
                    }),
                    /*#__PURE__*/ _jsx(MenuTitle, {
                        mt: 3,
                        children: "Labels"
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        label: "All tree labels",
                        icon: LocalOfferOutlined,
                        action: "VIEW_LABELS"
                    }),
                    labels && /*#__PURE__*/ _jsx(TopicPageViewsTopicMenuLabels, {
                        labels: labels,
                        rootURL: rootURL
                    }),
                    /*#__PURE__*/ _jsx(MenuTitle, {
                        mt: 3,
                        children: "Other Stuff"
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        label: "Tree activity",
                        icon: Timeline,
                        action: "VIEW_ACTIVITY"
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        label: "Tree archive",
                        icon: ArchiveOutlined,
                        action: "VIEW_ARCHIVE"
                    }),
                    isPartOfTopic && /*#__PURE__*/ _jsx(MenuItem, {
                        label: "Tree trash",
                        icon: AutoDeleteOutlined,
                        action: "VIEW_TRASH"
                    }),
                    authorization.leave && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Divider, {
                                my: 1,
                                mx: 3,
                                bg: "white.12"
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                label: "Leave tree",
                                icon: ExitToAppOutlined,
                                onClick: leaveTopic
                            })
                        ]
                    }),
                    !isSpecial && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Divider, {
                                my: 1,
                                mx: 3,
                                bg: "white.12"
                            }),
                            /*#__PURE__*/ _jsxs(Flex, _objectSpread({
                                height: "32px",
                                alignItems: "center",
                                px: 3
                            }, (owner === null || owner === void 0 ? void 0 : owner.type) === UserType.Team && {
                                as: Link,
                                to: `/${owner.username}`
                            }, {
                                children: [
                                    (owner === null || owner === void 0 ? void 0 : owner.type) === UserType.Team && /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Avatar, {
                                                user: owner,
                                                size: 32
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                fontSize: "15px",
                                                fontWeight: "medium",
                                                color: "white.100",
                                                ml: 1,
                                                mr: 3,
                                                children: owner.firstName || owner.username
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontSize: 1,
                                        color: "white.70",
                                        children: topicPublic ? "Public" : teamVisible ? "Team visible" : "Private"
                                    })
                                ]
                            }))
                        ]
                    })
                ]
            }))
        ]
    });
};
export default TopicPageViewsTopicMenu;
